import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, Mail, Navigation, CalendarDays } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { SHOWROOM } from "@/lib/showroom";

const Row = ({ icon: Icon, label, children, testId }) => (
  <div className="flex items-start gap-4 border-t border-[#D4AF37]/15 py-4" data-testid={testId}>
    <Icon className="w-4 h-4 mt-1 shrink-0 text-[#D4AF37]" />
    <div>
      <p className="font-mono-j text-[10px] uppercase tracking-[0.25em] text-[#A09E97]">{label}</p>
      <p className="mt-1 text-[#F5F3EF]">{children}</p>
    </div>
  </div>
);

export const ShowroomVisit = () => (
  <Reveal className="grid lg:grid-cols-[1fr_1.15fr] gap-10 lg:gap-16 items-stretch" data-testid="showroom-section">
    <div className="flex flex-col justify-between">
      <div>
        <Eyebrow>Visit the showroom</Eyebrow>
        <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl text-[#F5F3EF] leading-[1]">
          See it <em className="text-[#E5C158]">in person.</em>
        </h2>
        <p className="mt-6 text-[#A09E97] max-w-md">
          Every board, stone and handle in this catalogue is on display in Rochedale. Drop in during opening hours, or book a time and we'll have your shortlist laid out when you arrive.
        </p>
      </div>
      <div className="mt-10">
        <Row icon={MapPin} label="Address" testId="showroom-address">
          <a href={SHOWROOM.mapsHref} target="_blank" rel="noreferrer" className="hover:text-[#E5C158] transition-colors">{SHOWROOM.address}</a>
        </Row>
        <Row icon={Clock} label="Opening hours" testId="showroom-hours">{SHOWROOM.hours}</Row>
        <Row icon={Phone} label="Phone" testId="showroom-phone">
          <a href={SHOWROOM.phoneHref} className="hover:text-[#E5C158] transition-colors">{SHOWROOM.phone}</a>
        </Row>
        <Row icon={Mail} label="Email" testId="showroom-email">
          <a href={`mailto:${SHOWROOM.email}`} className="hover:text-[#E5C158] transition-colors">{SHOWROOM.email}</a>
        </Row>
        <div className="flex flex-col sm:flex-row gap-4 pt-6">
          <a href={SHOWROOM.mapsHref} target="_blank" rel="noreferrer" data-testid="showroom-directions-btn"
            className="h-14 inline-flex items-center justify-center gap-3 rounded-full bg-[#D4AF37] px-8 text-[#0D0D11] font-medium hover:bg-[#E5C158] transition-colors duration-300">
            <Navigation className="w-4 h-4" /> Get directions
          </a>
          <Link to="/selection" data-testid="showroom-book-btn"
            className="h-14 inline-flex items-center justify-center gap-3 rounded-full border border-[#D4AF37]/40 px-8 text-[#F5F3EF] hover:border-[#E5C158] hover:text-[#E5C158] transition-colors duration-300">
            <CalendarDays className="w-4 h-4" /> Book a consultation
          </Link>
        </div>
      </div>
    </div>

    <div className="relative min-h-[360px] lg:min-h-[560px] border border-[#D4AF37]/25 bg-[#13141C] overflow-hidden" data-testid="showroom-map">
      <iframe
        title="Sterling Joinery showroom map"
        src={SHOWROOM.mapEmbed}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
        className="absolute inset-0 w-full h-full border-0 [filter:invert(0.92)_hue-rotate(180deg)_saturate(0.35)_contrast(0.92)]"
      />
      <div className="pointer-events-none absolute inset-0 shadow-[inset_0_0_120px_rgba(13,13,17,0.9)]" />
      <div className="absolute left-5 bottom-5 bg-[#0D0D11]/90 backdrop-blur-md border border-[#D4AF37]/30 px-5 py-3">
        <p className="font-mono-j text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">Sterling Joinery</p>
        <p className="text-sm text-[#F5F3EF] mt-1">Rochedale, Brisbane</p>
      </div>
    </div>
  </Reveal>
);
